import * as LoadingActionTypes from './LoadingActionTypes';

export const showLoading = () => (dispatch) => {
  dispatch({ type: LoadingActionTypes.showLoadingType });
};

export const clearLoading = () => (dispatch) => {
  dispatch({ type: LoadingActionTypes.clearLoadingType });
};
